import React from 'react'
import { NavLink } from 'react-router-dom'

export default function YourAccount() {
  return (
    <NavLink className={({ isActive }) => isActive ? "nav-item nav-link active" : "nav-item nav-link"} to="/account">Your Account</NavLink>
  )
}